import {z} from 'zod';

import {BaseVoidRequestSchema, BaseVoidResponseSchema} from '@dms/api/shared';

/**
 * Base
 */
export const BaseVehicleClassSchema = z.object({
  vehicleClassId: z.string(),
  name: z.string(),
  isActive: z.boolean(),
});
export type BaseVehicleClass = z.infer<typeof BaseVehicleClassSchema>;

/**
 * GET
 */
export const GetVehicleClassesRequestSchema = BaseVoidRequestSchema;
export type GetVehicleClassesRequest = z.infer<typeof GetVehicleClassesRequestSchema>;

export const GetVehicleClassesResponseSchema = z.array(BaseVehicleClassSchema);
export type GetVehicleClassesResponse = z.infer<typeof GetVehicleClassesResponseSchema>;

export const GetVehicleClassRequestSchema = z.object({
  vehicleClassId: z.string(),
});
export type GetVehicleClassRequest = z.infer<typeof GetVehicleClassRequestSchema>;

export const GetVehicleClassResponseSchema = BaseVehicleClassSchema;
export type GetVehicleClassResponse = z.infer<typeof GetVehicleClassResponseSchema>;

/**
 * POST
 */
export const PostVehicleClassRequestSchema = z.object({
  name: z.string(),
});
export type PostVehicleClassRequest = z.infer<typeof PostVehicleClassRequestSchema>;

export const PostVehicleClassResponseSchema = z.object({
  vehicleClassId: z.string(),
});
export type PostVehicleClassResponse = z.infer<typeof PostVehicleClassResponseSchema>;

/**
 * PATCH
 */
export const PatchVehicleClassRequestSchema = z.object({
  vehicleClassId: z.string(),
  body: z
    .object({
      name: z.string(),
    })
    .optional(),
});
export type PatchVehicleClassRequest = z.infer<typeof PatchVehicleClassRequestSchema>;

export const PatchVehicleClassResponseSchema = BaseVoidResponseSchema;
export type PatchVehicleClassResponse = z.infer<typeof PatchVehicleClassResponseSchema>;

/**
 * DELETE
 */
export const DeleteVehicleClassRequestSchema = z.object({
  vehicleClassId: z.string(),
});
export type DeleteVehicleClassRequest = z.infer<typeof DeleteVehicleClassRequestSchema>;

export const DeleteVehicleClassResponseSchema = BaseVoidResponseSchema;
export type DeleteVehicleClassResponse = z.infer<typeof DeleteVehicleClassResponseSchema>;

/**
 * POST
 */
export const PostVehicleClassSetAsActiveRequestSchema = z.object({
  vehicleClassId: z.string(),
});
export type PostVehicleClassSetAsActiveRequest = z.infer<
  typeof PostVehicleClassSetAsActiveRequestSchema
>;

export const PostVehicleClassSetAsActiveResponseSchema = BaseVoidResponseSchema;
export type PostVehicleClassSetAsActiveResponse = z.infer<
  typeof PostVehicleClassSetAsActiveResponseSchema
>;

/**
 * POST
 */
export const PostVehicleClassSetAsInactiveRequestSchema = z.object({
  vehicleClassId: z.string(),
});
export type PostVehicleClassSetAsInactiveRequest = z.infer<
  typeof PostVehicleClassSetAsInactiveRequestSchema
>;

export const PostVehicleClassSetAsInactiveResponseSchema = BaseVoidResponseSchema;
export type PostVehicleClassSetAsInactiveResponse = z.infer<
  typeof PostVehicleClassSetAsInactiveResponseSchema
>;
